<template>
  <div class="input__card">
    <span class="input input--inline disabled">
      XXX
    </span>
    <span class="input input--inline disabled">
      XX
    </span>
    <input
      id="ssn"
      v-model="$v.ssn.$model"
      type="number"
      class="input input--inline"
      placeholder=""
      pattern="\d*"
      name="ssn"
      :class="{'input--error' : ($v.ssn.$invalid === true && $v.ssn.$error === true)}"
      @focusout="updateSSN"
    >
    <span
      v-show="$v.ssn.$invalid === true && $v.ssn.$error === true"
      class="input__error"
    >
      Invalid SSN code
    </span>
  </div>
</template>

<script>

import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
  props: ['ssnProp'],
  data () {
    return {
      ssn: ''
    }
  },
  watch: {
    '$v.ssn.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.ssn)
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
    }
  },
  mounted () {
    this.ssn = ''
    if (this.ssnProp) {
      this.ssn = parseInt(this.ssnProp)
    }
  },
  validations: {
    ssn: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(4),
      numeric
    }
  },
  methods: {
    updateSSN () {
      if (this.ssn.$invalid !== true && this.ssn.$error !== true) {
        this.$emit('input', this.ssn)
      }
    },
    triggerTouch () {
      this.$v.$touch()
    }
  }
}
</script>
